export const applicationRouteNames = {
  home: 'home',

  admin: 'admin',
  affiliates: 'affiliates',
  assets: 'assets-management',
  fields: 'fields',
  opportunities: 'opportunities',
  opportunityCampaigns: 'opportunity-campaigns',
  reports: 'reports',
  userManagement: 'user-management',
  wells: 'wells',
};
